<template>
  <b-modal
    no-fade
    id="modal-taxa-planner"
    no-close-on-esc
    no-close-on-backdrop
    size="lg"
    @show="onShow"
    title="Taxa Planner"
  >
    <b-form-row>
      <b-col offset-md="4" offset-lg="4" md="4" sm="12" lg="4">
        <b-form-group label="Nova Taxa Planner" label-size="sm" label-for="nova_taxa">
          <b-input-group>
            <b-form-input
              size="sm"
              maxlength="20"
              v-model="taxaPlanner"
              trim
              id="nova_taxa"
              autocomplete="off"
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 4,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
            <b-input-group-append>
              <b-button size="sm" @click="addTaxaPlanner" variant="success">
                Adicionar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-table
          :items="taxas"
          :fields="campos"
          bordered
          head-variant="dark"
          small
          striped
          hove
          show-empty
          empty-text="Sem registros para exibir"
        >
        </b-table>
      </b-col>
    </b-form-row>

    <template v-slot:modal-footer>
      <b-button size="sm" @click="() => $bvModal.hide('modal-taxa-planner')">Fechar</b-button>
    </template>
    <UIBlocker :isShow="isBusy"> Aguarde... </UIBlocker>
  </b-modal>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import UIBlocker from "../../layout/UIBlocker.vue";
import { formatDate, formatMoney } from "@/global";

export default {
  name: "ModalTaxaPlanner",
  components: { UIBlocker },
  props: {
    programaID: { type: String, required: true },
  },
  computed: {},
  data: function() {
    return {
      tabIndex: 0,
      taxaPlanner: 0.0,
      taxas: [],
      isBusy: false,
      campos: [
        {
          key: "dt_taxa",
          label: "Data",
          formatter: function(val) {
            return formatDate(val, "YYYY-MM-DD", "DD/MM/YYYY");
          },
        },
        {
          key: "cotacao",
          label: "Cotação",
          formatter: function(val) {
            return formatMoney(val, 4, "", ".", ",");
          },
        },
        { key: "usuario", label: "Usuário" },
      ],
    };
  },
  methods: {
    addTaxaPlanner() {
      this.$bvModal
        .msgBoxConfirm(`Atualizar todas as cotações do Programa?`, {
          noFade: true,
          okTitle: "Alterar",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            let _dadosPost = {
              'cotacao': this.taxaPlanner
            }
            this.isBusy = true;
            axios
              .post(`${baseApiUrl}/bid/programas/taxaplanner/${this.programaID}`, _dadosPost)
              .then(() => {
                this.onShow();
                this.isBusy = false;
              })
              .catch((err) => {
                this.isBusy = false;
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    onShow() {
      // tipos de servico
      axios
        .get(`${baseApiUrl}/bid/programas/taxaplanner/${this.programaID}`)
        .then((resp) => {
          console.log(resp.data);
          this.taxas = resp.data;
        })
        .catch(showError);
    },
  },
};
</script>

<style></style>
